// huoqu zidianxiang
import http from "./http"
let showLoading = false

export const getDict = id => {
  return http({ method: 'get', url: `/manager/api/v1/dict/${id}`,showLoading })
}
